import React from "react";
import { useQuery } from "@apollo/client";
import { Row, Col } from "react-bootstrap";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Legend, LabelList } from "recharts";
import { GET_PREVIOUS_MONTH_DEFICIENCIES_ENFORCEMENTS } from "../../../queries/archiveQrys/secureQrys/enfDashboardQrys";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";

const PrevMonthDefEnf = () => {
  const { loading, error, data } = useQuery(GET_PREVIOUS_MONTH_DEFICIENCIES_ENFORCEMENTS);
  if (loading)
    return (
      <>
        <h3>Previous Month Deficiencies and Enforcements</h3>
        <SkeletonLoader width='100%' />
      </>
    );
  if (!data)
    return (
      <>
        <h3>Previous Month Deficiencies and Enforcements</h3>
        <span>No Data Returned</span>
      </>
    );
  if (error) return <ErrorHandler error={error} />;

  return (
    <React.Fragment>
      <Row>
        <Col>
          <h3>Previous Month Deficiencies and Enforcements</h3>
        </Col>
      </Row>
      <Row>
        <Col cypressid='previousMonthDefBarChart'>
          <BarChart
            width={500}
            height={300}
            data={data.getPreviousMonthDeficienciesEnforcements}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5
            }}
          >
            <CartesianGrid strokeDasharray='3 3' />
            <XAxis dataKey='name' />
            <YAxis />
            <Legend verticalAlign='top' align={"left"} iconSize={0} width='100%' height={60} />
            <Bar name='Significant Deficiencies' dataKey='value1' fill='#0080b7'>
              <LabelList dataKey='value1' position='top' fill='#0080b7' />
            </Bar>
            <Bar name='Minor Deficiencies' dataKey='value2' fill='#add362'>
              <LabelList dataKey='value2' position='top' fill='#add362' />
            </Bar>
            <Bar name='Enforcement Actions' dataKey='value3' fill='#6d6e71'>
              <LabelList dataKey='value3' position='top' fill='#6d6e71' />
            </Bar>
          </BarChart>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default PrevMonthDefEnf;
